import { FormService } from './FormService';

export class PrintingNcrService extends FormService {
    constructor() {
        super("PrintingNcrs");
    }
}